// extracted by mini-css-extract-plugin
module.exports = {"root":"errorMessage_root__pg_n4","errorMessage":"errorMessage_errorMessage__foFZM text-e73635 leading-normal text-error text-sm"};